import moment from 'moment';

const getLastMonth = () => moment().subtract(1, 'month');

const destructDate = date => ({
  year: date.format('YYYY'),
  month: date.format('MM'),
  week: date.format('WW'),
  day: date.format('DD'),
  hour: date.format('HH'),
});

const friendlyDate = (date, locale = 'en', format = 'll') => moment(date).locale(locale).format(format);
// eslint-disable-next-line import/prefer-default-export
export { destructDate, getLastMonth, friendlyDate };



// WEBPACK FOOTER //
// ./src/helpers/date.js